import React, { useState, useContext, useEffect, useRef } from "react";
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink } from "@chakra-ui/react";
import {
  IconButton,
  TextField,
  Button,
  InputLabel,
  MenuItem,
  FormControl,
  Select,
  Autocomplete,
  Checkbox,
  Collapse,
  Modal,
  Typography,
  List,
  ListItem,
  Box, // Agregado
  Grid,
  Divider,
  Stack,
} from "@mui/material";

import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";

import { Close as CloseIcon } from "@mui/icons-material";

import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { red } from "@mui/material/colors"; // Para aplicar color rojo

import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import DeleteIcon from "@mui/icons-material/Delete"; // Ícono de eliminar
import PersonAddAltIcon from "@mui/icons-material/PersonAddAlt";

import { ErpContext } from "../../context/ErpContext.js";

const CreateItemProveedor = () => {
  const {
    getItemTresLetras,
    itemTresLetras,
    getEntidadFilterTipoEntidad,
    getItemProveedor,
    updateItemProveedor,
    postItemProveedor,isNavbarCollapsed,
  } = useContext(ErpContext);

  const [searchText, setSearchText] = useState(""); // Texto de búsqueda
  const [filteredItems, setFilteredItems] = useState([]);
  const [selectedItem, setSelectedItem] = useState(null); // Almacena el ítem seleccionado, el id y sus datos
  const [selectedProveedor, setSelectedProveedor] = useState(null);
  const [itemList, setItemList] = useState([]); // Lista de ítems con cantidad

  const [temporaryValue, setTemporaryValue] = useState("");

  const [proveedores, setProveedores] = useState([]); // Inicializa como un array vacío

  const [cantidadMontoItem, setCantidadMontoItem] = useState(0); // Inicializa como un array vacío

  useEffect(() => {
    const fetchData = async () => {
      try {
        // * HARDCODED *
        const entidadesProveedores = await getEntidadFilterTipoEntidad(2);

        setProveedores(entidadesProveedores);
      } catch (error) {}
    };
    fetchData();
  }, []); // Sin dependencias, se ejecuta solo al montar el componente

  // useEffect para manejar la lógica de búsqueda
  useEffect(() => {
    if (searchText.length >= 3) {
      getItemTresLetras(searchText); // Llama a la API
    } else {
      setFilteredItems([]); // Vacía las opciones si hay menos de 3 letras
    }
  }, [searchText]); //Este paramatro searchText condiciona al useEffect, detectando sus cambios. Solo se ejecuta si cambia el valor del input de searchText.

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
  }));

  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    "&:last-child td, &:last-child th": {
      border: 0,
    },
  }));

  const handleAddItem = async () => {
    if (selectedItem && cantidadMontoItem) {
      try {
        const newItem = {
          descripcion: selectedItem.descripcion,
          codigo: selectedItem.codigo,
          idItem: selectedItem.id,
          costo: cantidadMontoItem,
        };

        const updatedItems = [...itemList, newItem];

        setItemList(updatedItems);
      } catch (error) {
        if (error.response) {
          console.error(
            "Error en la respuesta del servidor:",
            error.response.data
          );
        } else if (error.request) {
          console.error("Error en la solicitud:", error.request);
        } else {
          console.error("Error en la configuración:", error.message);
        }
      }
    }
  };

  const handleUpdateItem = async (index, newCosto) => {
    try {
      // Mapea las promesas de actualización
      const updatedItems = await Promise.all(
        itemList.map(async (it, i) => {
          if (i === index) {
            return {
              ...it,
              descripcion: it.descripcion,
              codigo: it.codigo,
              costo: Number(newCosto),
              idItem: selectedItem.id,
            };
          }
          return it;
        })
      );

      // Actualiza el estado con los elementos modificados
      setItemList(updatedItems);
    } catch (error) {
      console.error("Error actualizando el item:", error);
    }
  };

  // Eliminar ítem individual
  const handleDeleteItem = (index) => {
    const itemToRemove = itemList[index];
    setItemList(itemList.filter((_, i) => i !== index));
  };

  const handleEnviarItemProveedor = async () => {
    if (!itemList.length || !selectedProveedor) {
      console.error("Debe seleccionar un proveedor y agregar al menos un ítem.");
      return;
    }
    try {
      const promises = itemList.map(async (it) => {
        console.log('Revisando item: ', it.idItem);
        const existeItemProveedor = await getItemProveedor(it.idItem, selectedProveedor.id);
        
        if (existeItemProveedor) {
          console.log('Actualizando costo para el ítem:', it.idItem);
          await updateItemProveedor(it.idItem, selectedProveedor.id, it.costo);
        } else {
          console.log('Creando nuevo ítem para el proveedor:', it.idItem);
          await postItemProveedor(it.idItem, selectedProveedor.id, it.costo);
        }
      });
  
      // Ejecutar todas las promesas a la vez
      await Promise.all(promises);
      console.log('Todos los ítems han sido procesados correctamente.');
    } catch (error) {
      console.error("Error al procesar los ítems del proveedor:", error);
    }
  };

  return (
    <>
      <Box className="containerCreateItemProveedor">
        <Box className="containerCreateItemProveedorInputs">
          <Autocomplete
            size="small"
            disablePortal
            options={itemTresLetras.map((it) => ({
              label: it.codigo + " - " + it.descripcion,
              descripcion: it.descripcion,
              codigo: it.codigo,
              id: it.id,
            }))} // Mapea la descripción para mostrar y el ID para capturar el ítem seleccionado
            value={selectedItem}
            onChange={(event, newValue) => {
              setSelectedItem(newValue);
            }} // Actualiza el ítem seleccionado
            onInputChange={(event, newInputValue) => setSearchText(newInputValue)} // Actualiza el texto de búsqueda
            style={{ width: 300, paddingRight: 10 }}
            renderInput={(params) => (
              <TextField {...params} label="Buscar ítem" />
            )}
          />

          <TextField
            size="small"
            label="Costo"
            variant="outlined"
            className="cantidadItemVentas"
            value={cantidadMontoItem}
            onChange={(e) => setCantidadMontoItem(e.target.value)}
          />

          <Autocomplete
            size="small"
            disablePortal
            options={(proveedores || []).map((it) => ({
              label:
              it.descripcion + " - " + it.apellido + " - " + it.dniCuitCuil,
              nombre: it.nombre,
              apellido: it.apellido,
              id: it.id,
              dniCuitCuil: it.dniCuitCuil,
            }))}
            value={selectedProveedor}
            onChange={(event, newValue) => {
              setSelectedProveedor(newValue);
            }} // Actualiza el ítem seleccionado
            style={{ width: 300, paddingRight: 10 }}
            renderInput={(params) => (
              <TextField {...params} label="Buscar Proveedor" />
            )}
          />

          <IconButton
className="colorGeneralParaIconos" onClick={handleAddItem}>
            <AddCircleOutlineIcon />
          </IconButton>
        </Box>

      <TableContainer
        component={Paper}
        className="containerGenerarVentaComponentTabla"
      >
        <Table className="tablaColumnaItems" aria-label="customized table">
          <TableHead>
            <TableRow>
              <StyledTableCell>Item</StyledTableCell>
              <StyledTableCell align="right">Costo</StyledTableCell>
              <StyledTableCell align="right">Eliminar</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {/*************************************************************************************************************************************/}
            {/*************************************************************************************************************************************/}
            {/*************************************************************************************************************************************/}
            {/* ITEM DE LA VENTA REFLEJADOS EN LA TABLA */}
            {itemList.map((it, index) => (
              <StyledTableRow key={index}>
                {/* Codigo + descripcion */}
                <StyledTableCell>
                  {it.codigo} - {it.descripcion}
                </StyledTableCell>

                <StyledTableCell align="right">
                  <TextField
                    type="number"
                    defaultValue={it.costo} // Default value, no se reinicia con cada render
                    className="inputTextFieldNumber"
                    size="small"
                    onBlur={(e) => handleUpdateItem(index, e.target.value)} // Se ejecuta solo al salir
                  />
                </StyledTableCell>

                {/* Eliminar */}
                <StyledTableCell align="right">
                  <IconButton
className="colorGeneralParaIconos"
                    edge="end"
                    onClick={() => handleDeleteItem(index)}
                  >
                    <DeleteIcon />
                  </IconButton>
                </StyledTableCell>
              </StyledTableRow>
            ))}
            {/*************************************************************************************************************************************/}
            {/*************************************************************************************************************************************/}
            {/*************************************************************************************************************************************/}
          </TableBody>
        </Table>
      </TableContainer>

      <div className={`contenedorCantidadItem ${itemList.length > 0 ? "visible" : "hidden"}`}>
              <div className="contenedorItemSelectVenta">
                <p className="tituloItemSelect">ITEMS:</p>
                <p className="itemSelect">{itemList.length}</p>
              </div>
              <Button onClick={handleEnviarItemProveedor}>
        Crear/Actualizar item proveedores
      </Button>
      </div>
      </Box>
    </>
  );
};

export default CreateItemProveedor;
